import React from 'react';
import { CarouselComponent } from '../about-us/CarouselComponent';
import { SwiperSlide } from 'swiper/react';
import { Title } from '../title';
import { CardTestimonialLarge } from './cardTestimonialLarge';
import { ContainerBase } from '../containers';

export const Testimonials: React.FC = () => {
	const testimonials = [
		{
			description:
				"Lowey's team showed the utmost professionalism when working on my case and were diligent throughout. My lawyers explained the process in detail and were always available to answer any questions I had. ",
			name: 'Ted Hozza',
		},
		{
			description:
				'The Lowey data privacy team has been great to work with. They walked me through the case every step of the way and answered any questions I had. I would definitely recommend them.',
			name: 'Nick Rapak',
		},
		{
			description:
				'The Lowey folks were great to work with. They kept me apprised about updates in my case through the entire process.',
			name: 'Michael Kilgore',
		},
		{
			description:
				'The Lowey team was a pleasure to work with. They kept me updated about my case every step up the way, including settlement. I would highly recommend them.',
			name: 'Edward del Hierro',
		},
	];
	return (
		<ContainerBase className="lg:!pt-[124px] !pb-[60px]">
			<Title description={'Trusted by clients nationwide.'}>Testimonial</Title>
			<div className="max-w-full overflow-hidden px-2 lg:px-0">
				<CarouselComponent
					id="testimonials"
					amountPages={testimonials.length}
					classNameSwiperContainer="lg:!h-[241px]"
					classNameContainerControls="!justify-center !ml-0"
					breakPoints={{
						0: {
							slidesPerView: 1,
							spaceBetween: 20,
						},
					}}
				>
					{testimonials.map((value, index) => (
						<SwiperSlide key={index}>
							<CardTestimonialLarge
								key={index}
								text={value.description}
								name={value.name}
							/>
						</SwiperSlide>
					))}
				</CarouselComponent>
			</div>
		</ContainerBase>
	);
};
